// Holland 직업 흥미 유형(RIASEC) 문항 데이터
// 각 유형별 15문항 × 6유형 = 90문항, 0~10점 척도
// 같은 개념을 서로 다른 표현으로 3번씩 물어(병렬 문항) 응답 일관성을 측정한다.
// groupId가 같은 문항끼리 내용이 사실상 같다.

export interface HollandQuestion {
  id: string;
  type: 'R' | 'I' | 'A' | 'S' | 'E' | 'C';
  groupId: string;
  statement: string;
}

export const hollandQuestions: HollandQuestion[] = [
  // === 현실형 (R) ===
  { id: 'h01', type: 'R', groupId: 'r1', statement: '기계나 전자기기를 분해하고 다시 조립하는 일이 재미있다' },
  { id: 'h02', type: 'R', groupId: 'r1', statement: '전자제품을 뜯어서 구조를 살펴보고 다시 맞추는 것을 좋아한다' },
  { id: 'h03', type: 'R', groupId: 'r1', statement: '장난감이나 가전제품을 분해해 원리를 확인하는 것이 즐겁다' },

  { id: 'h04', type: 'R', groupId: 'r2', statement: '직접 손으로 무언가를 만들거나 수리하는 활동을 좋아한다' },
  { id: 'h05', type: 'R', groupId: 'r2', statement: '손을 써서 물건을 제작하거나 고치는 일이 즐겁다' },
  { id: 'h06', type: 'R', groupId: 'r2', statement: '내 손으로 뭔가를 뚝딱 만들어내는 데 보람을 느낀다' },

  { id: 'h07', type: 'R', groupId: 'r3', statement: '운동이나 신체 활동을 하며 에너지를 쓰는 것이 좋다' },
  { id: 'h08', type: 'R', groupId: 'r3', statement: '몸을 움직이며 땀 흘리는 활동이 즐겁다' },
  { id: 'h09', type: 'R', groupId: 'r3', statement: '앉아 있기보다 밖에서 몸을 쓰는 것을 더 좋아한다' },

  { id: 'h10', type: 'R', groupId: 'r4', statement: '도구나 장비를 다루는 일이 편하게 느껴진다' },
  { id: 'h11', type: 'R', groupId: 'r4', statement: '연장이나 장비를 능숙하게 사용하는 데 자신이 있다' },
  { id: 'h12', type: 'R', groupId: 'r4', statement: '기계 장비를 조작하는 일에 흥미를 느낀다' },

  { id: 'h13', type: 'R', groupId: 'r5', statement: '설명서나 도면을 보며 직접 조작하는 것을 즐긴다' },
  { id: 'h14', type: 'R', groupId: 'r5', statement: '조립 설명서를 따라 만들거나 도면을 읽는 것이 재미있다' },
  { id: 'h15', type: 'R', groupId: 'r5', statement: '그림 설명서나 도면을 보고 무언가를 만드는 것을 좋아한다' },

  // === 탐구형 (I) ===
  { id: 'h16', type: 'I', groupId: 'i1', statement: '자연 현상이나 과학적 원리를 탐구하는 것이 즐겁다' },
  { id: 'h17', type: 'I', groupId: 'i1', statement: '과학적 원리와 자연 현상에 대해 궁금해하며 파고든다' },
  { id: 'h18', type: 'I', groupId: 'i1', statement: '세상이 돌아가는 원리를 과학적으로 이해하고 싶다' },

  { id: 'h19', type: 'I', groupId: 'i2', statement: '복잡한 문제를 논리적으로 분석하는 것을 좋아한다' },
  { id: 'h20', type: 'I', groupId: 'i2', statement: '어려운 문제를 차근차근 따져서 푸는 데 재미를 느낀다' },
  { id: 'h21', type: 'I', groupId: 'i2', statement: '논리적으로 생각해 결론을 내리는 과정이 즐겁다' },

  { id: 'h22', type: 'I', groupId: 'i3', statement: '실험이나 관찰을 통해 새로운 사실을 알아내는 것이 재미있다' },
  { id: 'h23', type: 'I', groupId: 'i3', statement: '직접 실험하고 관찰하며 결과를 확인하는 것을 좋아한다' },
  { id: 'h24', type: 'I', groupId: 'i3', statement: '무언가를 관찰해 새로운 사실을 발견하는 데 즐거움을 느낀다' },

  { id: 'h25', type: 'I', groupId: 'i4', statement: '궁금한 주제를 깊이 파고들어 공부하는 것을 좋아한다' },
  { id: 'h26', type: 'I', groupId: 'i4', statement: '한 가지 관심사에 빠져 깊게 알아보는 것을 즐긴다' },
  { id: 'h27', type: 'I', groupId: 'i4', statement: '흥미 있는 분야를 끝까지 깊이 탐구하는 데 몰입한다' },

  { id: 'h28', type: 'I', groupId: 'i5', statement: '수학이나 과학 문제를 풀 때 즐거움을 느낀다' },
  { id: 'h29', type: 'I', groupId: 'i5', statement: '수학 문제나 과학 문제를 푸는 것이 재미있다' },
  { id: 'h30', type: 'I', groupId: 'i5', statement: '복잡한 수학·과학 문제를 풀어낼 때 성취감을 느낀다' },

  // === 예술형 (A) ===
  { id: 'h31', type: 'A', groupId: 'a1', statement: '그림, 음악, 글쓰기 등으로 내 생각을 표현하는 것을 좋아한다' },
  { id: 'h32', type: 'A', groupId: 'a1', statement: '음악·미술·글 등 예술로 나를 표현하는 것이 즐겁다' },
  { id: 'h33', type: 'A', groupId: 'a1', statement: '내 생각과 감정을 예술적 방식으로 표현하고 싶다' },

  { id: 'h34', type: 'A', groupId: 'a2', statement: '독창적인 아이디어를 떠올리는 것이 즐겁다' },
  { id: 'h35', type: 'A', groupId: 'a2', statement: '남들과 다른 새로운 아이디어를 생각해내는 것을 좋아한다' },
  { id: 'h36', type: 'A', groupId: 'a2', statement: '기발하고 참신한 발상을 떠올리는 데 재미를 느낀다' },

  { id: 'h37', type: 'A', groupId: 'a3', statement: '예술 작품을 감상하거나 창작하는 데 시간을 보내는 것을 좋아한다' },
  { id: 'h38', type: 'A', groupId: 'a3', statement: '전시나 공연을 보거나 직접 작품을 만드는 것을 즐긴다' },
  { id: 'h39', type: 'A', groupId: 'a3', statement: '예술 작품을 감상하고 직접 창작하는 시간을 소중히 여긴다' },

  { id: 'h40', type: 'A', groupId: 'a4', statement: '정해진 틀보다 자유롭게 상상하는 것을 즐긴다' },
  { id: 'h41', type: 'A', groupId: 'a4', statement: '틀에 얽매이지 않고 자유롭게 상상하는 것을 좋아한다' },
  { id: 'h42', type: 'A', groupId: 'a4', statement: '정답 없이 마음껏 상상하는 활동이 즐겁다' },

  { id: 'h43', type: 'A', groupId: 'a5', statement: '내 감정을 독특한 방식으로 표현하고 싶다' },
  { id: 'h44', type: 'A', groupId: 'a5', statement: '느끼는 감정을 남다른 방법으로 드러내고 싶다' },
  { id: 'h45', type: 'A', groupId: 'a5', statement: '내 마음을 특별한 방식으로 표현하는 것을 좋아한다' },

  // === 사회형 (S) ===
  { id: 'h46', type: 'S', groupId: 's1', statement: '다른 사람의 고민을 듣고 도와주는 것을 좋아한다' },
  { id: 'h47', type: 'S', groupId: 's1', statement: '친구의 고민을 들어주고 함께 해결해주는 것이 즐겁다' },
  { id: 'h48', type: 'S', groupId: 's1', statement: '주변 사람들의 어려움을 듣고 돕는 데 보람을 느낀다' },

  { id: 'h49', type: 'S', groupId: 's2', statement: '친구에게 무언가를 가르치거나 설명해주는 것이 즐겁다' },
  { id: 'h50', type: 'S', groupId: 's2', statement: '남에게 지식을 전달하고 설명해주는 것을 좋아한다' },
  { id: 'h51', type: 'S', groupId: 's2', statement: '누군가를 가르치며 성장을 돕는 일이 즐겁다' },

  { id: 'h52', type: 'S', groupId: 's3', statement: '봉사 활동이나 남을 돕는 일에서 보람을 느낀다' },
  { id: 'h53', type: 'S', groupId: 's3', statement: '자원봉사나 도움이 필요한 사람을 돕는 일에 의미를 느낀다' },
  { id: 'h54', type: 'S', groupId: 's3', statement: '사회를 위해 봉사하는 활동에서 큰 보람을 느낀다' },

  { id: 'h55', type: 'S', groupId: 's4', statement: '사람들과 어울리며 협력하는 것을 좋아한다' },
  { id: 'h56', type: 'S', groupId: 's4', statement: '여럿이 힘을 합쳐 함께 일하는 것이 즐겁다' },
  { id: 'h57', type: 'S', groupId: 's4', statement: '사람들과 함께 어울려 협동하는 것을 좋아한다' },

  { id: 'h58', type: 'S', groupId: 's5', statement: '다른 사람의 감정을 잘 이해하고 공감하는 편이다' },
  { id: 'h59', type: 'S', groupId: 's5', statement: '상대방의 마음을 잘 헤아리고 공감한다' },
  { id: 'h60', type: 'S', groupId: 's5', statement: '다른 사람의 입장과 감정을 잘 이해한다' },

  // === 진취형 (E) ===
  { id: 'h61', type: 'E', groupId: 'e1', statement: '모임이나 팀에서 주도적으로 나서는 것을 좋아한다' },
  { id: 'h62', type: 'E', groupId: 'e1', statement: '그룹 활동에서 앞장서 이끄는 것을 즐긴다' },
  { id: 'h63', type: 'E', groupId: 'e1', statement: '팀에서 주도적인 역할을 맡는 것을 좋아한다' },

  { id: 'h64', type: 'E', groupId: 'e2', statement: '다른 사람을 설득하고 내 의견을 이끌어내는 것이 즐겁다' },
  { id: 'h65', type: 'E', groupId: 'e2', statement: '내 생각을 논리적으로 전달해 상대를 설득하는 것을 좋아한다' },
  { id: 'h66', type: 'E', groupId: 'e2', statement: '사람들을 설득해 내 의견대로 움직이게 하는 데 재미를 느낀다' },

  { id: 'h67', type: 'E', groupId: 'e3', statement: '경쟁을 통해 목표를 달성할 때 성취감을 느낀다' },
  { id: 'h68', type: 'E', groupId: 'e3', statement: '남과 경쟁하며 이겨내는 데서 성취감을 얻는다' },
  { id: 'h69', type: 'E', groupId: 'e3', statement: '경쟁에서 목표를 이루어낼 때 큰 보람을 느낀다' },

  { id: 'h70', type: 'E', groupId: 'e4', statement: '새로운 프로젝트나 일을 기획하는 데 흥미가 있다' },
  { id: 'h71', type: 'E', groupId: 'e4', statement: '새로운 일을 계획하고 추진하는 것을 좋아한다' },
  { id: 'h72', type: 'E', groupId: 'e4', statement: '아이디어를 내고 계획을 세워 실행하는 데 관심이 있다' },

  { id: 'h73', type: 'E', groupId: 'e5', statement: '사람들 앞에서 발표하거나 이끄는 것을 좋아한다' },
  { id: 'h74', type: 'E', groupId: 'e5', statement: '여러 사람 앞에서 말하고 이끄는 것을 즐긴다' },
  { id: 'h75', type: 'E', groupId: 'e5', statement: '무대나 회의에서 앞에 나서 발표하는 것을 좋아한다' },

  // === 관습형 (C) ===
  { id: 'h76', type: 'C', groupId: 'c1', statement: '데이터나 자료를 정리하고 체계적으로 기록하는 것을 좋아한다' },
  { id: 'h77', type: 'C', groupId: 'c1', statement: '자료를 정돈하고 규칙에 맞게 기록하는 것이 즐겁다' },
  { id: 'h78', type: 'C', groupId: 'c1', statement: '정보를 체계적으로 분류하고 정리하는 일이 재미있다' },

  { id: 'h79', type: 'C', groupId: 'c2', statement: '규칙과 절차를 지키며 정확하게 일하는 것이 편하다' },
  { id: 'h80', type: 'C', groupId: 'c2', statement: '정해진 규칙대로 꼼꼼하게 처리하는 것을 좋아한다' },
  { id: 'h81', type: 'C', groupId: 'c2', statement: '절차를 지키며 정확히 일하는 데 안정감을 느낀다' },

  { id: 'h82', type: 'C', groupId: 'c3', statement: '숫자나 자료를 분석해 정리하는 데 능숙하다' },
  { id: 'h83', type: 'C', groupId: 'c3', statement: '숫자를 다루고 자료를 분석하는 일이 즐겁다' },
  { id: 'h84', type: 'C', groupId: 'c3', statement: '데이터를 분석해 의미를 찾아내는 것을 잘한다' },

  { id: 'h85', type: 'C', groupId: 'c4', statement: '계획을 세우고 체계적으로 실행하는 것을 좋아한다' },
  { id: 'h86', type: 'C', groupId: 'c4', statement: '일을 순서대로 계획해 차근차근 진행하는 것을 즐긴다' },
  { id: 'h87', type: 'C', groupId: 'c4', statement: '체계적인 계획을 세워 실행하는 데 능숙하다' },

  { id: 'h88', type: 'C', groupId: 'c5', statement: '세부 사항을 꼼꼼하게 확인하고 정리하는 것을 즐긴다' },
  { id: 'h89', type: 'C', groupId: 'c5', statement: '작은 부분까지 놓치지 않고 확인하는 것을 좋아한다' },
  { id: 'h90', type: 'C', groupId: 'c5', statement: '세밀한 부분까지 꼼꼼히 살피고 정돈하는 것이 즐겁다' },
];